import { Fragment, memo, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { HooksService } from 'basic-components';
import { ArrowLeft, LogoWithText } from 'basic-components/icons';
import TimeService from 'dashboard-services/services/TimeService';

import properties from 'resources/constants/properties.json';

import { Else, If, Then, When } from 'react-if';

import './Title.scss';

const Title = ({ animationStarted, expanded, setExpandedFalse, switchExpanded }) => {
  const [defaultImg, setDefaultImg] = useState(false),
        definedTime = useSelector(state => state.myAccountState.settingsState.definedTime),
        [currentTime, setCurrentTime] = useState(TimeService.getCurrentTime(definedTime)),
        isDev = process.env.NODE_ENV !== 'production',
        isLocalHost = properties.version === "LOCALHOST"

  HooksService.useInterval(() => {
    setCurrentTime(TimeService.getCurrentTime(definedTime))
  }, 1000)
  
  return (
    <div className="sidebar__title-row">
      <div 
          className="sidebar__title-row__element sidebar__title-row__element--logo"
          onClick={switchExpanded}
      >
        <div className="sidebar__title-row__element__bg"/>
        <div className="sidebar__title-row__element__content">
          <If condition={properties.logoUrl !== "" && !defaultImg}>
            <Then>
              {() => (
                <img 
                    onError={() => setDefaultImg(true)}
                    src={properties.logoUrl}
                />
              )}
            </Then>
            <Else>
              {() => (
                <div className="image-component">
                  <LogoWithText/>
                </div>
              )}
            </Else>
          </If>
        </div>
        <When condition={isDev && !isLocalHost}>
          {() => (
            <div className="sidebar__title-row__element__dev">DEV</div>
          )}
        </When>
        <When condition={isLocalHost}>
          {() => (
            <div className="sidebar__title-row__element__dev">Local</div>
          )}
        </When>
      </div>
      <When condition={expanded && !animationStarted}>
        {() => (
          <Fragment>
            <div className="sidebar__title-row__timezone">
              <div className="sidebar__title-row__timezone__time">
                {currentTime}
              </div>
              <div className="sidebar__title-row__timezone__zone">
                {definedTime} <br/>
                {definedTime !== TimeService.UTC ? `${TimeService.UTC} ${TimeService.getTimezoneOffset(definedTime)}` : ""}
              </div>
            </div>
            <div 
                className="sidebar__title-row__element sidebar__title-row__element--close"
                onClick={setExpandedFalse}
            >
              <div className="sidebar__title-row__element__bg"/>
              <div className="sidebar__title-row__element__content">
                <ArrowLeft
                    color="blue-bright"
                    height={24}
                    width={24}
                />
              </div>
            </div>

          </Fragment>
        )}
      </When>
    </div>
  )
}

Title.propTypes = {
  animationStarted: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
  setExpandedFalse: PropTypes.func.isRequired,
  switchExpanded: PropTypes.func.isRequired
}

export default memo(Title)